import { Box, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CoursesApi from '../../../apis/CoursesApi';
import LoadingCircle from '../../../components/LoadingCircle/LoadingCircle';
import useApi from '../../../lib/useApi';
import { CoursePreview } from '../sections/CourseSection';

/**
 * The course card shows a preview of the course to the user
 */
const CourseCard = (coursePreviewDto: CoursePreview) => {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(true);
  const coursesApi = useApi(CoursesApi);
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    let localImageUrl = '';
    coursesApi
      .GetCourseCard(coursePreviewDto.slug)
      .then((b) => {
        localImageUrl = window.URL.createObjectURL(b);
        setImageUrl(localImageUrl);
      })
      .catch(() => {
        if (theme.palette.mode == 'dark')
          setImageUrl('./s3g-thumbnail-dark.png');
        else setImageUrl('./s3g-thumbnail-light.png');
      })
      .finally(() => setIsLoading(false));

    return () => {
      if (localImageUrl != '') window.URL.revokeObjectURL(localImageUrl);
    };
  }, [coursePreviewDto.slug, coursesApi, theme.palette.mode]);

  return (
    <Box position="relative" height="100%">
      <Box
        component={Link}
        data-testid={coursePreviewDto.slug}
        to={`/training/courses/${coursePreviewDto.slug}`}
        height="100%"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: '.5em',
          borderRadius: '.4em',
          backgroundImage: `linear-gradient(transparent, ${coursePreviewDto.baseColor}), url('${imageUrl}')`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          textDecoration: 'none',
          cursor: 'pointer',
          transition: 'all .2s ease-in-out',
          '&:hover': {
            boxShadow: `0px 1.5em 1.5em -20px ${
              theme.palette.mode == 'light' ? 'black' : '#333333'
            }`,
            transform: 'scale(1.04)',
          },
        }}
      >
        <Box width="100%" display="flex" justifyContent="flex-end">
          <Typography
            color="white"
            fontWeight="bold"
            sx={{
              textShadow: '2px 2px 6px rgba(0, 0, 0, 0.8)',
            }}
          >
            {coursePreviewDto.required ? '(Required)' : '(Optional)'}
          </Typography>
        </Box>
        <Box
          width="100%"
          display="flex"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <Typography color="white" fontWeight="bold" fontSize="1.2rem">
            {coursePreviewDto.title}
          </Typography>
          <Box display="flex">
            <Typography color="white" marginRight=".4em">
              Progress
            </Typography>
            <Typography color="white" fontWeight="bold">
              {coursePreviewDto.progress}%
            </Typography>
          </Box>
        </Box>
      </Box>
      <LoadingCircle isLoading={isLoading} hideText />
    </Box>
  );
};

export default CourseCard;
